<template>
    <v-container>
        <v-row>
            <v-col cols="2">Название стажировки:</v-col>
            <v-col>{{title}}</v-col>
        </v-row>
        <v-row>
            <v-col cols="2">Срок стажировки:</v-col>
            <v-col>{{Dat}}</v-col>
        </v-row>
        <v-row>
            <v-col cols="2">
                Оплачиваемая стажировка:
            </v-col>
            <v-col v-if="Summa">{{Summa}}</v-col>
            <v-col v-else> Увы нет </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    props:["title","Dat", "Summa"]
}
</script>